import { useEffect } from 'react';
import selector from './selector';

function query(url, setter) {
    useEffect(() => {
        selector(url)
            .then((body) => {
                setter(body);
            })
            .catch(() => {});
    }, []);
}

export default query;
